import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { RouterModule, ActivatedRoute, RouterLink, Router } from '@angular/router';
import { DashboardService } from './dashboard.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { UtilService } from 'src/app/shared/helper/util.service';
import { HomePageService } from 'src/app/shared/services/homepage.service';
import * as _ from 'lodash';
import { AuthService } from '@auth0/auth0-angular';
import { AnalyticsService } from '../analytics.service';

import { PageTransitionService } from 'src/app/shared/services/pageTransition.service';
import { ManageRequestsService } from '../../manage-requests/manage-requests.service';
import { MatDialog } from '@angular/material/dialog';
import { RequestAccessDialogComponent } from 'src/app/shared/request-access-dialog/request-access-dialog.component';

@Component({
    selector: 'app-dashboard-details',
    templateUrl: './dashboard-details.component.html',
    styleUrl: './dashboard-details.component.scss',
    standalone: false
})
export class DashboardDetailsComponent implements OnInit, AfterViewInit {

  isLoading = true
  private loadStartTime: number;

  @ViewChild('pageRoot') pageRoot: ElementRef | undefined;

  dashboard: any;
  userId: any='';
  successMessage: any;
  isUserLoggedIn: boolean;
  subscriptionMsg =
    'Please contact DMINT Administrator to get subscription of the same';
  errMsg: any;
  showErrorMessageWithPopup: boolean;
  closeSign: string;
  subscriptionDetails: any;
  analyticsModuleId: any;
  insightsModule: any;
  insightsData: any;
  headerId: any = 4;
  insightsModuleRecords: any[];
  searchText: any='';
  currentPage=1;
  sortBy= 'created_date';
  sortType= 'desc';
  getinsightsModules: any;
  allInsightsModulesHeaders: any;
  allProdcuts: any[];
  moduleByteMap: { [key: string]: any } = {};
  bussinessProductLine: any;
  userName: string;
  companyName: any;
  companyId: any;
  stepOneDetails: any;
 
  constructor(public route: ActivatedRoute, 
   public dashboardService: DashboardService,
   public analyticService: AnalyticsService,
   private spinnerService: NgxSpinnerService,
   private utilService: UtilService,
   private homePageService: HomePageService,
   public router: Router,
  private auth: AuthService,
  private pageTransition: PageTransitionService,
  private manageRequestService: ManageRequestsService,
  private dialog: MatDialog
  ) {}

dashboards: any =[];
  ngOnInit() {
    window.scrollTo({ top: 0, behavior: 'auto' }); 
        this.utilService.getHeaderId.subscribe((res:any) => this.headerId = res || this.headerId  );
    this.userDetails();
    this.userId = localStorage.getItem('userId')!='undefined'&&localStorage.getItem('userId')!=undefined?localStorage.getItem('userId'):'';
    this.isUserLoggedIn =  this.utilService.isUserLoggedIn();
    this.analyticsModuleId = +this.route.snapshot.params['id'];
    this.getHeader();
    this.utilService.moduleBytes.subscribe((mod) => {
        this.moduleByteMap = mod as Object;
      });
   }

  ngAfterViewInit() { 
    this.pageLoaded();
  }

  pageLoaded() {
    const minDelay = 1600; // 1.6 seconds
    const elapsed = Date.now() - this.loadStartTime;
    const remaining = Math.max(0, minDelay - elapsed);

    setTimeout(() => {
      this.isLoading = false;
      if (this.pageRoot?.nativeElement) {
        this.pageTransition.fadeIn(this.pageRoot.nativeElement);
      }
    }, remaining);
  }

  recommendedDashboards: any[] = [];
  visibleCards: any[] = [];
  currentIndex = 0;
  pageSize = 4;

  updateVisibleCards() {
  const start = this.currentIndex * this.pageSize;
  this.visibleCards = this.dashboard.similarDashboards.slice(start, start + this.pageSize);
  }
  
  next() {
    if ((this.currentIndex + 1) * this.pageSize < this.dashboard.similarDashboards.length) {
      this.currentIndex++;
      this.updateVisibleCards();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updateVisibleCards();
    }
  }
   getHeader(){
    this.homePageService.onHeader(this.userId).subscribe((res) => {
      this.spinnerService.hide();
      this.insightsModule = res;
      if (this.insightsModule.message === 'OK') {
        this.insightsData = this.insightsModule.result;
        this.insightsModuleRecords = [...this.insightsData];
        this.getUpdatedAnalyticsData()
        }
    });
  }
   getUpdatedAnalyticsData(flag=false){
      let userId = localStorage.getItem('userId');
      userId = userId == "undefined" ? null : userId;
  
      let payload: any = {
        "userId":userId,
        "headerId": this.headerId,
        "searchText": this.searchText,
        "categoryIds":  null,
        "regionIds":  null,
        "businessLineIds":  null,
        "functionIds":  null,
        "productLineIds":  null,
        "sortBy": this.sortBy,
        "sortType": this.sortType,
        "limit": 500,
        "page": this.currentPage
      }
      this.analyticService.getAllAnalyticsModules(payload, "analytics").subscribe(
        {
          next: (res: any) => {
            this.spinnerService.hide();
              this.getinsightsModules = res.result;
              for (let modulerecord of this.insightsModuleRecords) {
                if (modulerecord.headerName == 'Analytics') {
                  this.allInsightsModulesHeaders=_.cloneDeep(modulerecord.modules);        
                }         
              }
              if (this.getinsightsModules?.length > 0 ) {
                this.getinsightsModules.forEach((ele: any) => {
                  let index = this.allInsightsModulesHeaders?.findIndex((item: any) => item.id == ele.moduleId)
                  if (index > -1) {
                    ele.subscription = this.allInsightsModulesHeaders[index]['subscription'];
                    ele.moduleLink = this.allInsightsModulesHeaders[index]['moduleLink'];
                    ele.favorite = this.allInsightsModulesHeaders[index]['favorite'];
                    ele.isSingleUserGroup = this.allInsightsModulesHeaders[index].userGroups?.length==1;
                    ele.userGroups = this.allInsightsModulesHeaders[index].userGroups;
                  }
                })
                
                if (flag) {
                  this.allProdcuts = []
                  this.allProdcuts = [...this.allProdcuts, ...this.getinsightsModules];
                  this.getinsightsModules = _.cloneDeep(this.allProdcuts);
               
                }
              } else {
                this.getinsightsModules = _.cloneDeep(this.allProdcuts);
        }
        this.subscriptionDetails=this.getinsightsModules;
        this.getModuleDetails();
          },
          error: (err) => {
            this.spinnerService.hide()
            this.utilService.SharingDataTextMessage.subscribe((res: any) => {
              this.errMsg = res
            })
            this.showErrorMessageWithPopup = true;
            setTimeout(() => { this.showErrorMessageWithPopup = false; this.errMsg = ''; }, 5000)
          }
        }
      )
    }
  getModuleDetails(){
    let userId = localStorage.getItem('userId');
    userId = userId == "undefined" ? null : userId;
    let reqBody: { userId: any | null; moduleId: any } = {
          "userId": userId,
          "moduleId": this.analyticsModuleId
      }  
      this.analyticService.getAnalyticsDetailsById(reqBody).subscribe((res: any) => {      
      if (res?.result) {
        let dashboardWithSubscription={};
        let index = this.subscriptionDetails.findIndex((x: any) => x.id||x.moduleId == this.analyticsModuleId)
          if (index > -1) {
            dashboardWithSubscription = {
            ...res.result,
            newlyAdded:this.subscriptionDetails[index].newlyAdded,
            subscription:this.subscriptionDetails[index].subscription,
            isInternal:this.subscriptionDetails[index].isInternal,
            accessCompleted:this.subscriptionDetails[index].accessCompleted,
            favorite:this.subscriptionDetails[index].favorite,
            moduleLink:this.subscriptionDetails[index].moduleLink,
            tags: this.subscriptionDetails[index].tags,
            isSingleUserGroup: this.subscriptionDetails[index].userGroups?.length==1,
            userGroups: this.subscriptionDetails[index].userGroups
          };
          }
        this.dashboard = dashboardWithSubscription;
        this.updateVisibleCards();
      }
     })
        
  }
  toggleFavourite(module:any): void {
    module.favorite = !module.favorite;
    let reqBody = {
        "userId": this.userId,
        "moduleId": module.id||module.moduleId,
        "isFavourite": module.favorite
    }
    this.markUnmarkFavourite(reqBody);
  }
  markUnmarkFavourite(reqBody:any){
    this.analyticService.markUnmarkFavourite(reqBody).subscribe((response: any) => {      
      if(response.code == 200){
        this.successMessage = response.result;
        if(this.userId) this.getHeader()
        setTimeout(() => { this.successMessage = false; this.successMessage = ''; }, 3000)
      }
    })
  }
redirectToEmail() {
  let email = this.dashboard?.moduleOwnerEmail;
  const mailtoLink = `https://outlook.office.com/mail/deeplink/compose?to=${encodeURIComponent(email)}`;
  window.open(mailtoLink, '_blank');
}
  onSubscribe() { 
    this.errMsg = this.subscriptionMsg;
    this.closeSign = 'OK';
    this.showErrorMessageWithPopup = true;
  }
    onSignIn() {
    this.utilService.onSignIn();
  }
viewDetails(analyticsProduct: any) {
  let baseURL = window.location.origin;
  let redirectUrl = `${baseURL}/view-details/${analyticsProduct.moduleId || analyticsProduct.id}`;
  window.open(redirectUrl,'_self');
}
onCloseHandlerSub() {
    if (this.errMsg.includes('Session Expired')) {
      localStorage.clear();
      sessionStorage.clear();
      this.router.navigate(['/login'], { replaceUrl: true }).then(() => {
        this.auth.logout();
      });
    }else{
      this.errMsg = null;
      this.errMsg = null;
      this.showErrorMessageWithPopup = false;
    }
  }
  shareLink() {
    const baseURL = window.location.href;
    if (navigator.clipboard) {
      navigator.clipboard.writeText(baseURL).then(() => {
        const msg = document.getElementById("copyMsg");
        msg.style.display = "block";
        setTimeout(() => msg.style.display = "none", 2000);
      }).catch(err => {
        console.error('Failed to copy: ', err);
      });
    }
  }

  loadModule(dashboard: any){
    this.utilService.loadModule(dashboard);
  }
  userDetails(){
    this.userName = localStorage.getItem('userName');
    this.utilService.companyName.subscribe((res:any) => this.companyName = res);
    this.utilService.companyId.subscribe((res:any) => this.companyId = res);
  }
 
  createAccessRequestForSingleGroup(module:any){
        const apiPayload = {
              submittedByUserId: this.userId,
              companyId: this.companyId,
              headerId: this.headerId,
              moduleId: module?.moduleId,
              isModuleAttached: true,
              userGroups: module?.userGroups
            };
             this.manageRequestService.createAccessRequest(apiPayload).subscribe({
              next: (response:any) => {
                if(response.code == 200){
                  this.successMessage = response?.result;
                  setTimeout(() => { this.successMessage = ''; }, 5000);
                  this.getHeader();
                }
              },
              error: (error) => {
                this.errMsg = 'Failed to submit access request. Please try again.';
                this.showErrorMessageWithPopup = true;
                setTimeout(() => { this.errMsg = '';this.showErrorMessageWithPopup = false; }, 5000);
              }
            });
  }

  onAccessPending() { 
    this.errMsg = `Please contact <a 
      href='https://outlook.office.com/mail/deeplink/compose?to=platform@dacoval.com' 
      target='_blank' 
      class='admin-email-link'>
      DMINT Administrator
    </a> to get access for the same`
      this.closeSign = 'OK';
      this.showErrorMessageWithPopup = true;
  }

  onRequestAccessClick(module: any) {
    if(module.isSingleUserGroup){
      this.createAccessRequestForSingleGroup(module);
    }else{
      this.getStepOneDetails(module);
    }
  }

  getStepOneDetails(module: any){
      this.manageRequestService.getDataForSteps(module.moduleId).subscribe((res: any) => {
        if(res){
              this.stepOneDetails = res.result;
              this.stepOneDetails= this.stepOneDetails.sort((a:any, b:any) => a.stepNumber - b.stepNumber)
              this.callRequestPopup(module,this.stepOneDetails)
      }    
    });
  } 

  callRequestPopup(module:any,stepDetails:any){
      const dialogRef = this.dialog.open(RequestAccessDialogComponent, {
        width: '800px',
        maxWidth: '90vw',
        data: {
          module:module,
          stepDetails:stepDetails,
          title: `Request access to ${module.moduleName}`,
          panelClass: 'request-access-dialog',
          disableClose: false
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          // Handle business-specific data in parent component
          const apiPayload = {
            submittedByUserId: this.userId,
            companyId: this.companyId,
            headerId: this.headerId,
            moduleId: module?.moduleId,
            isModuleAttached: result?.isModuleAttached,
            userGroups: result?.userGroups
          };
    //    Submit to API
          this.manageRequestService.createAccessRequest(apiPayload).subscribe({
            next: (response:any) => {
              if(response.code == 200){
                this.successMessage = response?.result;
                setTimeout(() => { this.successMessage = ''; }, 5000);
                this.getHeader();
              }
            },
            error: (error) => {
              this.errMsg = 'Failed to submit access request. Please try again.';
              this.showErrorMessageWithPopup = true;
              setTimeout(() => { this.errMsg = '';this.showErrorMessageWithPopup = false; }, 5000);
            }
          });
        }
      });
      
  }  
}
